import { render, staticRenderFns } from "./VersicherungsbeginnKennzeichenFIN.vue?vue&type=template&id=41837482&"
import script from "./VersicherungsbeginnKennzeichenFIN.vue?vue&type=script&lang=js&"
export * from "./VersicherungsbeginnKennzeichenFIN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports